import { render, staticRenderFns } from "./SelectedItemsList.vue?vue&type=template&id=1a760380&scoped=true&"
import script from "./SelectedItemsList.vue?vue&type=script&lang=ts&"
export * from "./SelectedItemsList.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedItemsList.vue?vue&type=style&index=0&id=1a760380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a760380",
  null
  
)

export default component.exports